// ======================================================================
// File Name       : csvDownload
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const CSV_RECEIVE_SELECTED_GROUP = 'CSV_RECEIVE_SELECTED_GROUP';
export const CSV_RESET_SELECTED_FLAG = 'CSV_RESET_SELECTED_FLAG';
export const CSV_OPEN_SELECT_GROUP_DIALOG = 'CSV_OPEN_SELECT_GROUP_DIALOG';
export const CSV_RESET_SHOW_GROUP_FLAG = 'CSV_RESET_SHOW_GROUP_FLAG';
export const CSV_RESET_SELECTED_COURSE_BOX_LIST = 'CSV_RESET_SELECTED_COURSE_BOX_LIST';
export const CSV_RESET_SELECTED_GROUP_LIST = 'CSV_RESET_SELECTED_GROUP_LIST';
export const CSV_RECEIVE_SERVICE_USER_LIST = 'CSV_RECEIVE_SERVICE_USER_LIST';
export const CSV_RECEIVE_COURSE_LIST = 'CSV_RECEIVE_COURSE_LIST';
export const CSV_RECEIVE_ADDED_COURSE_LIST = 'CSV_RECEIVE_ADDED_COURSE_LIST';
export const CSV_RECEIVE_TARGET_COURSE_LIST = 'CSV_RECEIVE_TARGET_COURSE_LIST';
export const CSV_RECEIVE_TARGET_CONTENT_LIST = 'CSV_RECEIVE_TARGET_CONTENT_LIST';
export const CSV_RECEIVE_TARGET_USER_LIST = 'CSV_RECEIVE_TARGET_USER_LIST';
export const CSV_RESET_DATA = 'CSV_RESET_DATA';
export const CSV_RESET_CONTENT_DATA = 'CSV_RESET_CONTENT_DATA';
export const CSV_RESET_USER_DATA = 'CSV_RESET_USER_DATA';
export const CSV_RECEIVE_ITEM_LIST = 'CSV_RECEIVE_ITEM_LIST';
export const CSV_RECEIVE_ADDED_CONTENT_LIST = 'CSV_RECEIVE_ADDED_CONTENT_LIST';
export const CSV_RECEIVE_ADDED_USER_LIST = 'CSV_RECEIVE_ADDED_USER_LIST';
export const CSV_RESET = 'CSV_RESET';
export const CSV_RESET_USER_DIALOG = 'CSV_RESET_USER_DIALOG';
export const CSV_RESET_COURSE_DIALOG = 'CSV_RESET_COURSE_DIALOG';
export const CSV_RESET_CONTENT_DIALOG = 'CSV_RESET_CONTENT_DIALOG';
export const CSV_RECEIVE_BOX_LIST = 'CSV_RECEIVE_BOX_LIST';
export const CSV_RESET_BOX_DIALOG = 'CSV_RESET_BOX_DIALOG';
export const CSV_RESET_BOX_DATA = 'CSV_RESET_BOX_DATA';
export const CSV_RECEIVE_ADDED_BOX_LIST = 'CSV_RECEIVE_ADDED_BOX_LIST';
export const CSV_RECEIVE_TARGET_BOX_LIST = 'CSV_RECEIVE_TARGET_BOX_LIST';